import { api } from '@/config/axios'
import type { Patient } from '@/types'

export interface UpdatePatientPayload {
    consultation_market_consent?: boolean
}

export const getCurrentPatient = async (): Promise<Patient> => {
    const response = await api.get('/auth/patient-profile', {})
    return response.data.patient
}

export const updatePatient = async (id: number, payload: UpdatePatientPayload): Promise<Patient> => {
    const response = await api.put(`/patient/${id}`, payload)
    return response.data.patient
}
